import { Bell, Bug, Database, Key, Link2, Lock, Moon, Shield, ShieldCheck, User } from 'lucide-react';
export const SETTINGS_SECTIONS = [
    {
        id: 'profile',
        label: 'Profile',
        icon: User
    },
    {
        id: 'notifications',
        label: 'Notifications',
        icon: Bell
    },
    {
        id: 'security',
        label: 'Security',
        icon: Shield
    },
    {
        id: 'sso',
        label: 'Single Sign-On',
        icon: Lock
    },
    {
        id: 'authorization',
        label: 'Authorization Policies',
        icon: ShieldCheck
    },
    {
        id: 'data',
        label: 'Data & Privacy',
        icon: Database
    },
    {
        id: 'appearance',
        label: 'Appearance',
        icon: Moon
    },
    {
        id: 'api',
        label: 'API Keys',
        icon: Key
    },
    {
        id: 'sharepoint',
        label: 'SharePoint',
        icon: Link2
    },
    // 'users' moved to the unified /admin console (polish task 04); the
    // ?section=users deep link still redirects there from Settings.tsx.
    {
        id: 'bug-reports',
        label: 'Bug Reports',
        icon: Bug
    }
];
export const TIMEZONE_OPTIONS = [
    {
        value: 'America/New_York',
        label: 'Eastern Time'
    },
    {
        value: 'America/Chicago',
        label: 'Central Time'
    },
    {
        value: 'America/Denver',
        label: 'Mountain Time'
    },
    {
        value: 'America/Los_Angeles',
        label: 'Pacific Time'
    },
    {
        value: 'UTC',
        label: 'UTC'
    }
];
export const SESSION_TIMEOUT_OPTIONS = [
    {
        value: 15,
        label: '15 minutes'
    },
    {
        value: 30,
        label: '30 minutes'
    },
    {
        value: 60,
        label: '1 hour'
    },
    {
        value: 240,
        label: '4 hours'
    },
    {
        value: 480,
        label: '8 hours'
    }
];
